import React from 'react'

import styles from './Loading.module.scss'

export default function Loading() {
  return (
    <div className={styles['loading-container']}>
      <svg
        width="420"
        height="100"
        viewBox="0 0 420 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          x="0"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0s' }}
        >
          C
        </text>
        <text
          x="40"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.1s' }}
        >
          l
        </text>
        <text
          x="62"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.2s' }}
        >
          o
        </text>
        <text
          x="100"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.3s' }}
        >
          v
        </text>
        <text
          x="136"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.4s' }}
        >
          e
        </text>
        <text
          x="172"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.5s' }}
        >
          r
        </text>
        <text
          x="230"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.7s' }}
        >
          A
        </text>
        <text
          x="272"
          y="50"
          className={styles['loading-container__letter']}
          style={{ animationDelay: '0.8s' }}
        >
          I
        </text>
      </svg>
    </div>
  )
}
